import React, { Component } from "react";
import Property from "../../components/property-details";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { bindActionCreators } from "redux";
import Error from "../../components/error.js";
import GetImovel from "../../client_api";

import {
  setCurrentProfile,
  removeCurrentProfile
} from "../../../modules/profile";
import EmpresaContext from "../../context";

const frontload = async props => {
  try {
    console.log(props.apiURL);
    let result = await GetImovel(
      props.apiURL,
      `imovel/${props.match.params.id}`
    );
    return await props.setCurrentProfile(result);
  } catch (error) {
    console.log(`/api/imovel/${props.match.params.id}`, error);
  }
};

class PropertyProfile extends Component {
  componentDidMount() {
    if (!this.props.imovel) {
      console.log(
        "route property: ",
        this.props.match.params.id,
        this.props.empresa_id
      );
    }
  }
  componentWillUnmount() {
    this.props.removeCurrentProfile();
  }

  render() {
    let imgSrc;
    if (
      !this.props.imovel ||
      (this.props.imovel && this.props.imovel.excluido) ||
      (this.props.imovel && this.props.imovel.pendente) ||
      (this.props.imovel && this.props.imovel.ocultar_no_site)
    )
      return <Error />;
    try {
      let fotoDestaque =
        this.props.imovel &&
        this.props.imovel.fotos.find(e => e.destaque === true);
      let orderedFotos = this.props.imovel.fotos.sort(
        (a, b) =>
          a.destaque
            ? -1
            : parseInt(String(a.ordem)) - parseInt(String(b.ordem))
      );
      imgSrc = fotoDestaque
        ? fotoDestaque.resized || fotoDestaque.source.uri
        : orderedFotos[0].resized || orderedFotos[0].source.uri;
    } catch (_) {
      imgSrc = this.context.logo;
    }
    return (
      <>
        <Helmet>
          <title>
            {this.props.imovel.codigo
              ? `Imóvel #${this.props.imovel.codigo}`
              : "Carregando imóvel..."}
          </title>
          <meta
            name="description"
            content={
              this.props.imovel.descrição ||
              `Imóvel #${this.props.imovel.codigo}`
            }
          />
          <meta property="og:locale" content="pt_BR" />
          <meta
            property="og:url"
            content={this.context.url_compartilhamento || this.context.url[0]}
          />
          <meta property="og:type" content={"website"} />
          <meta
            property="og:site_name"
            content={this.context.nome_fantasia || this.context.nome}
          />
          <meta
            property="og:title"
            content={
              this.props.imovel.titulo || `Imóvel #${this.props.imovel.codigo}`
            }
          />
          <meta
            property="og:description"
            content={
              this.props.imovel.descrição ||
              `Imóvel #${this.props.imovel.codigo}`
            }
          />
          <meta property="og:image" content={imgSrc} />
        </Helmet>
        <Property imovel={this.props.imovel} />
      </>
    );
  }
}

PropertyProfile.contextType = EmpresaContext;

const mapStateToProps = state => ({
  imovel: state.profile.currentProfile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setCurrentProfile, removeCurrentProfile }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false
  })(PropertyProfile)
);
